$(window).on("load", function() {
    $('.yomi li:nth-child(2) .inner,.yomi li:nth-child(3) .inner,.yomi li:nth-child(4) .inner,.yomi li:nth-child(5) .inner,.yomi li:nth-child(6) .inner,.yomimono_list li:nth-child(7) .inner').addClass('tile3');
});

$(window).on('load resize orientationchange', function() {
    if (window.matchMedia('(min-width: 850px)').matches) {
        $(function() {
            $('.tile').tile(2);
        })
    } else if (window.matchMedia('(min-width: 849px)').matches) {
        $(function() {
            $('.tile').tile(1);
        })
    } else {
        $(function() {
            $('.tile').tile(2);
        })
    }
});

$(window).on('load resize orientationchange', function() {
    if (window.matchMedia('(min-width: 1079px)').matches) {
        $(function() {
            $('.tile3').tile(3);
        })
    } else if (window.matchMedia('(max-width: 1080px)').matches) {
        $(function() {
            $('.tile3').tile(2);
        })
    } else {
        $(function() {
            $('.tile3').tile(3);
        })
    }
});



$(window).on('load resize orientationchange', function() {
    if (window.matchMedia('(min-width: 640px)').matches) {
        $(function() {
            $('.tile4').tile(4);
        })
    } else if (window.matchMedia('(min-width: 639px)').matches) {
        $(function() {
            $('.tile4').tile(2);
        })
    } else {
        $(function() {
            $('.tile4').tile(2);
        })
    }
});



$(window).on('load resize orientationchange', function() {
    if (window.matchMedia('(min-width: 850px)').matches) {
        $(function() {
            $('.tile5').tile(10);
        })
    } else if (window.matchMedia('(min-width: 849px)').matches) {
        $(function() {
            $('.tile5').tile(3);
        })
    } else {
        $(function() {
            $('.tile5').tile(10);
        })
    }
});